import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel } from "swiper/modules";

const CategoriesSlider = ({
  menuCategories,
  setSelectedCategory,
  selectedCategory,
}) => {
  return (
    <div className="py-2 px-4">
      <div className="max-w-full">
        <Swiper
          modules={[Mousewheel]}
          mousewheel={true}
          spaceBetween={16}
          breakpoints={{
            0: {
              spaceBetween: 8,
            },
            640: {
              spaceBetween: 12,
            },
          }}
          slidesPerView={"auto"}
          className="max-w-full"
          wrapperClass="max-w-full"
        >
          {menuCategories?.map((item: any, index: number) => {
            if (item.visibility === 1)
              return (
                <SwiperSlide key={index} className="!w-auto">
                  <div
                    role="button"
                    onClick={() => setSelectedCategory(item.title)}
                    key={item.id}
                    className={`px-2 sm:px-3 py-1 rounded-lg cursor-pointer text-sm sm:text-base ${
                      selectedCategory === item.title
                        ? "bg-red text-white"
                        : "bg-green text-black"
                    }`}
                  >
                    {item.title}
                  </div>
                </SwiperSlide>
              );
          })}
        </Swiper>
      </div>
    </div>
  );
};

export default CategoriesSlider;
